import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import moment from 'moment';
import ItemRow from '@components/ActionsCommon/ItemRows';
const DialogsViewDetail = (props) => {
  const { userInfo, openView, setOpenView, refetch } = props;
  const handleClose = () => {
    setOpenView(false);
  };
  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openView}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Chi tiết khách hàng</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <ItemRow title="Tên đăng nhập:" value={userInfo?.username} />
            <ItemRow title="Họ và tên:" value={userInfo?.full_name} />
            <ItemRow title="Email:" value={userInfo?.email} />
            <ItemRow title="Ngày tháng năm sinh:" value={userInfo?.date_of_birth} />
            <ItemRow title="Avatar:" value={userInfo?.avatar} />
            <ItemRow title="Giới tính:" value={userInfo?.gender === 1 ? 'Nam' : 'Nữ'} />
            <ItemRow title="Địa chỉ:" value={userInfo?.address} />
            <ItemRow title="Quốc gia:" value={userInfo?.country} />
            <ItemRow
              title="Trạng thái:"
              value={userInfo?.status === true ? 'Đã xác nhận' : 'Chưa xác nhận'}
            />
            <ItemRow
              title="Thời gian tạo:"
              value={moment(userInfo?.created_date).format('DD-MM-YYYY HH:mm')}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Đóng
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogsViewDetail;
